function o_MMS_Admin_Login_Methods(engine) {
  this.engine = engine;
}

o_MMS_Admin_Login_Methods.prototype = {
}

export {
  o_MMS_Admin_Login_Methods
}





// WEBPACK FOOTER //
// ./src/assets/octopus/methods/MMS/Admin/Login.js